import React, { useRef, useState, useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { toSnakeCase } from '../helpers/common';
import { useDraggable } from 'react-use-draggable-scroll';
import useIntersectionObserver from '../helpers/useIntersectionObserver';

const AnchorLinks = (props) => {
  const listRef = useRef(); // Ref to reference the wrapping div:
  const { events } = useDraggable(listRef); // pass reference to the useDraggable hook:

  const { modules, module } = props;
  const { title } = module;
  const handleAnchorClick = (scrollClickEvent, clickTarget) => {
    scrollClickEvent.preventDefault();
    if (triggerRef.current) {
      document.body.style.scrollPaddingTop = `${triggerRef.current.offsetHeight}px`;
    } else {
      document.body.style.scrollPaddingTop = null;
    }

    let scrollTarget = document.getElementById(clickTarget);
    scrollTarget &&
      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
  };

  const triggerRef = useRef();
  const dataRef = useIntersectionObserver(triggerRef, {
    freezeOnceVisible: false,
  });
  const [anchorPosition, setAnchorPosition] = useState();

  //
  useEffect(() => {
    setAnchorPosition(dataRef?.boundingClientRect?.y);
  }, [dataRef?.boundingClientRect?.y, anchorPosition]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('anchor-links__wrapper--pinned', e.intersectionRatio < 1),
      {
        threshold: [1],
      }
    );
    observer.observe(triggerRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  const [loaded, setLoaded] = useState();
  const [elements, setElements] = useState();
  const [currentModuleArray, setCurrentModuleArray] = useState();
  const [currentModule, setCurrentModule] = useState();

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setCurrentModule(entry.target.id);
      }
    });
  };

  useEffect(() => {
    if (currentModuleArray) {
      const options = {
        rootMargin: '-20% 0px -80%',
        root: document,
      };

      currentModuleArray.forEach((element) => {
        const observer = new IntersectionObserver(observerCallback, options);
        observer.observe(element);
      });
    }
  }, [currentModuleArray, currentModule]);

  useEffect(() => {
    if (!loaded) {
      setElements(document.querySelectorAll('section[id]'));
      setLoaded(true);
    }
    if (loaded && !currentModuleArray) {
      const arr = Array.from(elements);
      setCurrentModuleArray(arr);
    }
  }, [loaded, currentModuleArray, elements]);

  const anchorLinkItems = modules.map((module, i) => {
    let anchorTagLinkText;
    if (module.anchorTagLinkText) {
      anchorTagLinkText = toSnakeCase(module.anchorTagLinkText);
    }
    return (
      module.anchorTagLinkText && (
        <a
          className={`${
            currentModule === anchorTagLinkText
              ? 'anchor_links__current-module'
              : ''
          } anchor_links__link body-two-semi-bold`}
          key={i}
          href={`#${anchorTagLinkText}`}
          onClick={(scrollClickEvent) =>
            handleAnchorClick(scrollClickEvent, `${anchorTagLinkText}`)
          }
          aria-label={`Scroll to ${module.anchorTagLinkText}`}
        >
          {module.anchorTagLinkText}
        </a>
      )
    );
  });

  return (
    <nav
      ref={triggerRef}
      className="anchor-links__wrapper"
      style={
        anchorPosition <= 0
          ? { backgroundColor: '#F9F4F2' }
          : { backgroundColor: 'white' }
      }
    >
      <Container>
        <div className="grid-wrapper">
          <div className="anchor-links__container">
            <div className="anchor-links__list-wrapper">
              <div className="anchor-links__rails">
                <p className="body-five anchor-links__title">
                  {title ? title : 'Explore this page:'}
                </p>

                <div className="anchor-links__list-container">
                  <div ref={listRef} {...events} className="anchor-links__list">
                    {anchorLinkItems}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </nav>
  );
};

export default AnchorLinks;
